<template>
	<div v-loading="loading">
		<div style="min-height: calc(100vh - 255px)">
			<p class="title">{{ detaile.title }}</p>
			<p class="time">发布时间：{{ detaile.createTime | formatDate }}</p>
			<div v-html="detaile.content" style="width: 100%;padding-bottom: 30px;"></div>
			<div class="clearfix">
				<p v-if="detaile.beforeId" class="fl other fixsm1" :title="'上一篇：' + detaile.beforeTitle" @click="toNext(1)"><i class="el-icon-arrow-left"></i>上一篇：{{ detaile.beforeTitle }}</p>
				<p v-if="detaile.afterId" class="fr other fixsm2" :title="'下一篇：' + detaile.afterTitle" @click="toNext(2)">
					<span class="nxt-fixsm2">下一篇：{{ detaile.afterTitle }}</span>
					<i class="el-icon-arrow-right"></i>
				</p>
			</div>
		</div>
	</div>
</template>
  
  <script>
import { formatdate } from '@/utils/index'
export default {
	data() {
		return {
			detaile: {},
			loading: true,
			id: null,
		}
	},
	filters: {
		formatDate(time) {
			if (!time) return
			var date = new Date(time)
			return formatdate(date, 'yyyy-MM-dd hh:mm:ss')
		},
	},
	created() {
		this.id = this.$route.query.id
		if (this.id) {
			this.getDetail()
		}
	},
	methods: {
		getDetail() {
			this.loading = true
			this.$http
				.post(this.$api.goodsApi.getYNdetails, {
					id: this.$route.query.id,
				})
				.then(({ data }) => {
					this.detaile = data.data
					this.$nextTick(() => {
						this.loading = false
					})
				})
				.catch(() => {
					this.loading = false
				})
		},
		toNext(num) {
			this.loading = true
			if (num == 1) {
				this.$router.push({ name: 'hosequptDetail', query: { id: this.detaile.beforeId } })
				this.id = this.detaile.beforeId
			} else {
				this.$router.push({ name: 'hosequptDetail', query: { id: this.detaile.afterId } })
				this.id = this.detaile.afterId
			}
			this.getDetail()
		},
	},
}
</script>
  
  <style lang="scss" scoped>
.fixsm1 {
	width: 45%;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	position: absolute;
	bottom: 20px;
	margin-right: 50px;
}
.fixsm2 {
	max-width: 45%;
	position: absolute;
	bottom: 20px;
	right: 20px;
	display: flex;
	align-items: center;
}
.nxt-fixsm2{
	display: inline-block;
	width: 96%;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
.title {
	font-size: 20px;
	font-family: PingFang SC-Bold, PingFang SC;
	font-weight: bold;
	color: #333;
	text-align: center;
	margin: 0;
	line-height: 28px;

	&::after {
		width: 24px;
		height: 3px;
		border-radius: 6px;
		background: #D4D4D4;
		margin: 0 auto;
		content: '';
		display: block;
		position: relative;
		top: 8px;
	}
}

.time {
	font-size: 14px;
	font-family: PingFang SC-Regular, PingFang SC;
	line-height: 20px;
	color: #999;
	text-align: center;
	margin: 20px 0;
}

.other {
	font-size: 14px;
	cursor: pointer;
	font-family: PingFang SC-Regular, PingFang SC;
	font-weight: 400;
	color: #2962b0;
}
</style>
  